import { authAxios } from "@/api";
import { API_VER, ROOT_URL } from "@/setup/constants"

const API_CONTROLLER = "token";

export class AuthApi {
    static validateUser(formData){
        const config = {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }        
        const url= `${ROOT_URL}/${API_CONTROLLER}`;
        let data = new FormData();
        data.append('username', formData.username);
        data.append('password', formData.password);
        data.append('grant_type', 'password');
        return authAxios.post(url, data, config);
    }
}